/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { MappingProfileFieldDto } from './MappingProfileFieldDto';
import {
    MappingProfileFieldDtoFromJSON,
    MappingProfileFieldDtoFromJSONTyped,
    MappingProfileFieldDtoToJSON,
    MappingProfileFieldDtoToJSONTyped,
} from './MappingProfileFieldDto';

/**
 * 
 * @export
 * @interface MappingProfileDto
 */
export interface MappingProfileDto {
    /**
     * 
     * @type {string}
     * @memberof MappingProfileDto
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof MappingProfileDto
     */
    label?: string | null;
    /**
     * 
     * @type {ImportType}
     * @memberof MappingProfileDto
     */
    importType?: ImportType;
    /**
     * 
     * @type {{ [key: string]: Array<MappingProfileFieldDto>; }}
     * @memberof MappingProfileDto
     */
    columnMapping?: { [key: string]: Array<MappingProfileFieldDto>; } | null;
    /**
     * 
     * @type {string}
     * @memberof MappingProfileDto
     */
    defaultDateFormat?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MappingProfileDto
     */
    createdAt?: Date;
}



/**
 * Check if a given object implements the MappingProfileDto interface.
 */
export function instanceOfMappingProfileDto(value: object): value is MappingProfileDto {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    return true;
}

export function MappingProfileDtoFromJSON(json: any): MappingProfileDto {
    return MappingProfileDtoFromJSONTyped(json, false);
}

export function MappingProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappingProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'label': json['label'] == null ? undefined : json['label'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'columnMapping': json['columnMapping'] == null ? undefined : json['columnMapping'],
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function MappingProfileDtoToJSON(json: any): MappingProfileDto {
    return MappingProfileDtoToJSONTyped(json, false);
}

export function MappingProfileDtoToJSONTyped(value?: MappingProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'label': value['label'],
        'importType': ImportTypeToJSON(value['importType']),
        'columnMapping': value['columnMapping'],
        'defaultDateFormat': value['defaultDateFormat'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

